const listeners = {};

export function addListener(key, id, callback){
    if(!listeners[key]){
        listeners[key] = {}
    }
    listeners[key][id] = callback
}
export function removeListener(key, id){
    if(listeners[key] && listeners[key][id]){
        delete listeners[key][id]
    }
    if(Object.keys(listeners[key]).length === 0){
        delete listeners[key]
    }
}

export function trigger(key){
    const fns = listeners[key] || {};
    Object.values(fns).forEach(fn=> fn())
}